import React, { useState } from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import {
  IBlock,
  IButton,
  IImage,
  ILabel,
} from '../../../../utils/types/contentful';
import { Image } from '../../../UI/Media/Image';
import { Link } from '../../../UI/Elements/Link';
import { TrustpilotMiniReviews } from '../Trustpilot/trustpilotMiniReviews';
import { Grid } from '../../../UI/Grid/grid';
import { TextWithLine } from '../../Banners/BannerText/bannerText';
import { useMediaQuery } from '../../../../utils/hooks/useMediaQuery';

export interface SiteReviewProps {
  label: ILabel;
  body: ILabel;
  image: IImage;
  buttons: IButton[];
  reviews: IBlock[];
}

export const SiteReview = (props) => {
  const { label, subLabel, image, author, location } =
    formatContentfulComponentProps(props);

  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className='bg-white my-3 relative'
      onMouseEnter={() => setIsHover(true)}
      onMouseUp={() => setIsHover(true)}
      onMouseDown={() => setIsHover(false)}
      onMouseLeave={() => setIsHover(false)}>
      <div
        className={`bg-green-500 top-0 -z-1 absolute h-full w-full transform ease-in-out duration-300 border ${
          isHover ? 'rotate-3' : ''
        } cursor-pointer`}
      />
      <div className='relative bg-white'>
        <div className='h-48 p-6 relative overflow-hidden'>
          <div className='w-full flex justify-between items-center mb-4'>
            {/* Star image */}
            <div className='w-28'>
              <Image {...image} />
            </div>
            {/* Location marker */}
            <div className='flex items-center'>
              <Icon iconKey='HiOutlineLocationMarker' />
              <div className='pl-1'>
                <Label
                  {...location}
                  weight='medium'
                  color={{ classname: 'gray-800' }}
                />
              </div>
            </div>
          </div>
          <div className='mb-2'>
            <Label
              {...label}
              color={{ classname: 'gray-800' }}
              truncate
              weight='medium'
              size='xl'
            />
          </div>
          <Label
            {...subLabel}
            overflow-ellipsis
          />
        </div>
        <div className='flex items-end p-6'>
          <Label
            {...author}
            italic
            size='base'
          />
        </div>
      </div>
    </div>
  );
};

export const SiteReviews = ({ label, link, reviews }: MainReviewProps) => {
  const isWindowSmallSize = useMediaQuery('lg');
  return (
    <div className='w-full overflow-hidden'>
      <TextWithLine
        label={{
          ...label,
          size: isWindowSmallSize ? '4xl' : '6xl',
          color: { classname: 'gray-800' },
        }}
      />
      <div className='flex flex-col sm:flex-row w'>
        <Grid
          grid={{
            itemsGrow: false,
            isSlider: 'block',
            itemsWidth:
              'min-w-8/12 sm:min-w-5/12 sm:w-5/12 lg:min-w-4/14 lg:w-4/14',
            gridItems: [
              <div className='h-full flex items-center justify-center'>
                <TrustpilotMiniReviews />
              </div>,
              ...reviews?.items.map((review) => <SiteReview {...review} />),
            ],
          }}
        />
      </div>
    </div>
  );
};
